

















export default {
  props: {
    delay: { type: Number, default: 0 }
  },
  data() {
    return {
      waiting: true
    }
  },
  created() {
    this.timer = setTimeout(() => {
      this.waiting = false
    }, this.delay)
  },
  beforeDestroy() {
    clearTimeout(this.timer)
  }
}
